module.exports = __webpack_public_path__ + "img/hr-electric-mining-drill-E-drill-shadow.400f834b.png";